function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.076 4.463C3.21 4.181 3.5 4 3.818 4h16.364c.318 0 .608.18.742.463.134.283.088.616-.117.854l-6.352 7.344V19.2c0 .277-.147.535-.389.68-.24.146-.542.16-.796.036l-3.272-1.6c-.277-.136-.453-.413-.453-.716v-4.94L3.193 5.318c-.205-.238-.251-.571-.117-.854zM5.582 5.6l5.406 6.251c.125.145.194.328.194.517v4.738l1.636.8v-5.538c0-.19.069-.372.194-.517L18.418 5.6H5.582z",
  clipRule: "evenodd"
});

var SvgIcFilter = function SvgIcFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_filter.fd3be0af.svg";
export { ForwardRef as ReactComponent };